<!-- RightDrawer.vue -->
<template>
  <div>
    <transition name="drawer">
      <div v-if="isVisible" class="fixed inset-0 z-50 overflow-hidden">
        <div class="absolute inset-0">
          <!-- Overlay - semi-transparent background -->
          <div
            class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            @click="close"
          ></div>

          <!-- Drawer panel -->
          <div class="fixed inset-y-0 right-0 flex max-w-full">
            <div class="w-screen max-w-9/12 relative">
              <!-- Drawer content -->
              <div
                class="h-full flex flex-col bg-white shadow-xl overflow-y-auto"
              >
                <!-- Close button in top right -->
                <div class="absolute top-0 right-0 pt-4 pr-4 z-10">
                  <button
                    @click="close"
                    class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <span class="sr-only">Kapat</span>
                    <svg
                      class="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <!-- Main content area -->
                <div class="flex-1 p-6 overflow-y-auto">
                  <!-- Content will be injected here -->
                  <div v-if="htmlContent" v-html="htmlContent"></div>
                  <slot v-else></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, computed } from "vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  htmlContent: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:visible", "close"]);

// Computed property to sync with parent
const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});

const close = () => {
  isVisible.value = false;
  emit("close");
};

// Allow for locking body scroll when drawer is open
watch(
  () => isVisible.value,
  (open) => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  },
  { immediate: true }
);
</script>

<style scoped>
/* Animation for the drawer */
.drawer-enter-active,
.drawer-leave-active {
  transition: transform 0.3s ease-out;
}

.drawer-enter-from,
.drawer-leave-to {
  transform: translateX(100%);
}

.drawer-enter-to,
.drawer-leave-from {
  transform: translateX(0);
}

/* Custom width for the drawer */
.max-w-9\/12 {
  max-width: 75%;
  right: 0;
  float: right;
}
</style>
